/// <reference types="vite-plugin-svgr/client" />
import React from 'react';

import InfoIcon from '../../static/nike/info-icon.svg?react';
import BaseView from './BaseView';

export interface InfoViewProps {
    navbarItems?: React.ReactNode;
    title?: React.ReactNode;
    message?: React.ReactNode;
    hideInfoIcon?: boolean;
    onInactivity?: () => void;
}

function InfoView(props: InfoViewProps) {
    return (
        <BaseView
            onInactivity={props.onInactivity}
            navbarItems={props.navbarItems}>
            <div className='row justify-content-center'>
                <div className='col-xl-6 col-12'>
                    {props.hideInfoIcon !== true ? (
                        <div className='mt-4 mt-xl-1 d-flex flex-column align-items-center justify-content-start'>
                            <InfoIcon className='img-fluid w-50' />
                        </div>
                    ) : undefined}
                </div>
            </div>
            <h3 className='text-center mt-3 mt-xl-2'>{props.title}</h3>
            <p className='text-center'>{props.message}</p>
        </BaseView>
    );
}

export default InfoView;
